<template>
  <div class="approval-flow-stage d-flex flex-column ga-3 w-100">
    <div class="text-h2 text-textDarkest">
      Stage {{ stage.stage_number }}: {{ stage.name }}
    </div>

    <ApprovalFlowSlot
      v-for="approvalSlot in stage.slots"
      :key="approvalSlot.ulid"
      :flow-slot="approvalSlot"
      :mode="mode"
      :selected-users="getSelectedUsers(approvalSlot)"
      @update:selected-users="handleSelectedUsersUpdate(approvalSlot, $event)"
    />
  </div>
</template>

<script setup>
import ApprovalFlowSlot from '@/components/jobProfiles/editor/approvals/ApprovalFlowSlot.vue';
import { formatUserDisplayName } from '@/helpers/user';

const props = defineProps({
  stage: {
    type: Object,
    required: true,
  },
  mode: {
    type: String,
    default: 'view',
    validator: (value) => ['view', 'edit'].includes(value),
  },
  approvalSlotSelectedUsers: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:approvalSlotSelectedUsers']);

const getSelectedUsers = (approvalSlot) => {
  if (props.mode === 'edit') {
    return props.approvalSlotSelectedUsers[approvalSlot.ulid] ?? [];
  }

  return approvalSlot.approvers.map((approver) => ({
    id: approver.ulid,
    label: formatUserDisplayName(approver),
  }));
};

const handleSelectedUsersUpdate = (approvalSlot, selectedUsers) => {
  emit('update:approvalSlotSelectedUsers', approvalSlot.ulid, selectedUsers);
};
</script>
